import React from 'react'
import styles from "../Components/styles/Contribute.module.css"

const Faq = () => {
    return (
        <div className = {styles.faq}>
            <p>1. What is the company name?</p>
            <p>Company name is easyshopcart</p>

            <p>2. When it was established ?</p>
            <p>On May 15, 2021</p>

            <p>3. Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>
            <p> Quo quae eaque sint pariatur ab aspernatur saepe fuga eos dolor</p>

            <p>4. Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>
            <p> Quo quae eaque sint pariatur ab aspernatur saepe fuga eos dolor</p>
        </div>
    )
}

export  { Faq }
